/* Raghu  27/10/2022 3075154998 Card Stylings */
import React from 'react';
import {Grid} from '@material-ui/core';
export default function MapMediaTypeBox({
  mediaTypeData,
}) {
  return (
    <>
      <Grid item xs={12}>
        <div className="form-row global-field-textfields">
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Media Type Name :</b> {mediaTypeData.name ? mediaTypeData?.name : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4 col-md-8 col-lg-3  mt-3">
            <b>Description:</b> {mediaTypeData?.description ? mediaTypeData?.description : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>File Type:</b> {mediaTypeData.type ? mediaTypeData?.type : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Device/Rule Group:</b>{mediaTypeData?.deviceOrRuleGroup ? mediaTypeData?.deviceOrRuleGroup : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Device Type:</b> {mediaTypeData.deviceType ? mediaTypeData?.deviceType : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Fixed Length :</b>  {mediaTypeData.fixedLength ? mediaTypeData?.fixedLength : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Record Length:</b> {mediaTypeData.recordLength ? mediaTypeData?.recordLength : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Is Media Labelled:</b> {mediaTypeData.isLabeled ? mediaTypeData?.isLabeled : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Number of Label Records:</b> {mediaTypeData.noOfLabelRecord ? mediaTypeData?.noOfLabelRecord : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Label Record Length:</b> {mediaTypeData.labelRecordlength ? mediaTypeData?.labelRecordlength : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Record Terminator:</b> {mediaTypeData?.recordTerminator ? mediaTypeData?.recordTerminator : <span className="ml-3"> -- </span> }
          </div>
          <div className="col-sm-4  col-lg-3  mt-3">
            <b>Initialize Tape:</b> {mediaTypeData?.initializeTape ? mediaTypeData?.initializeTape : <span className="ml-3"> -- </span> }
          </div>
        </div>
      </Grid>
    </>
  );
}
